/* Hydro Flavor Finder — replaces the 33-item variant dropdown with a searchable,
   family-filtered, color-coded picker. Progressive enhancement over a native <select>. */
(function () {
  'use strict';
  var norm = function (s) { return (s || '').toUpperCase().replace(/\(.*?\)/g, '').replace(/[^A-Z0-9]/g, ''); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFinder(root) {
    if (root.dataset.ffReady) return;
    root.dataset.ffReady = '1';

    var select = root.querySelector('[data-ff-select]');
    var trigger = root.querySelector('[data-ff-trigger]');
    var modal = root.querySelector('[data-ff-modal]');
    var grid = root.querySelector('[data-ff-grid]');
    var chipsWrap = root.querySelector('[data-ff-chips]');
    var search = root.querySelector('[data-ff-search]');
    var countEl = root.querySelector('[data-ff-count]');
    var closeEls = root.querySelectorAll('[data-ff-close]');
    var pdp = root.closest('[data-hydro-pdp]') || document;

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ff-variants]').textContent); } catch (e) { return; }
    var flavorData = { families: [], flavors: {} };

    var activeFamily = 'All';
    var query = '';

    function meta(title) { return flavorData.flavors[norm(title)] || {}; }

    function updateTrigger(v) {
      var m = meta(v.title);
      var dot = root.querySelector('[data-ff-current-emoji]');
      var name = root.querySelector('[data-ff-current-name]');
      if (dot) { dot.textContent = m.emoji || '🍃'; if (m.accent) dot.style.background = m.accent; }
      if (name) name.textContent = m.name || v.title;
      if (trigger) trigger.classList.add('is-selected');
    }

    function applyVariant(v) {
      if (select) { select.value = String(v.id); select.dispatchEvent(new Event('change', { bubbles: true })); }
      updateTrigger(v);
      var priceEl = pdp.querySelector('[data-ff-price]');
      if (priceEl && v.price_money) priceEl.textContent = v.price_money;
      var img = pdp.querySelector('[data-ff-image]');
      if (img && v.image) { img.src = v.image; img.srcset = ''; }
      var atc = pdp.querySelector('[data-ff-atc]');
      if (atc) {
        atc.disabled = !v.available;
        var lbl = atc.querySelector('[data-ff-atc-label]') || atc;
        lbl.textContent = v.available ? (atc.dataset.labelAdd || 'Add to Cart') : (atc.dataset.labelSold || 'Sold out');
      }
    }

    function cardHTML(v) {
      var m = meta(v.title);
      var accent = m.accent || '#E8F8EE';
      var fam = m.family || '';
      var sub = m.descriptor || fam;
      var tag = '';
      if (m.bestseller) tag = '<span class="hydro-ff__tag">Bestseller</span>';
      else if (m.is_new) tag = '<span class="hydro-ff__tag hydro-ff__tag--new">New</span>';
      return '<button type="button" class="hydro-ff__card' + (v.available ? '' : ' is-sold') + '" data-variant-id="' + v.id + '">' +
        '<span class="hydro-ff__dot" style="background:' + accent + '">' + (m.emoji || '🍃') + '</span>' +
        '<span class="hydro-ff__txt"><span class="hydro-ff__name">' + (m.name || v.title) + '</span>' +
        '<span class="hydro-ff__sub">' + sub + '</span></span>' + tag +
        (v.available ? '' : '<span class="hydro-ff__sold">Sold out</span>') +
        '</button>';
    }

    function render() {
      var q = norm(query);
      var list = variants.filter(function (v) {
        var m = meta(v.title);
        if (activeFamily !== 'All' && m.family !== activeFamily) return false;
        if (q && norm((m.name || v.title)).indexOf(q) === -1) return false;
        return true;
      });
      grid.innerHTML = list.map(cardHTML).join('') || '<p class="hydro-ff__empty">No flavors match. Try another search.</p>';
      if (countEl) countEl.textContent = list.length + (list.length === 1 ? ' flavor' : ' flavors');
    }

    function buildChips() {
      var fams = ['All'].concat(flavorData.families || []);
      chipsWrap.innerHTML = fams.map(function (f) {
        return '<button type="button" class="hydro-ff__chip' + (f === 'All' ? ' is-active' : '') + '" data-family="' + f + '">' + f + '</button>';
      }).join('');
    }

    var lastFocus = null;
    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      render();
      if (search) { search.value = ''; query = ''; setTimeout(function () { search.focus(); }, reduceMotion ? 0 : 120); }
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () { modal.hidden = true; modal.removeEventListener('transitionend', done); };
      if (reduceMotion) done(); else modal.addEventListener('transitionend', done);
      if (lastFocus) lastFocus.focus();
    }

    trigger.addEventListener('click', openModal);
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    if (search) search.addEventListener('input', function () { query = search.value; render(); });
    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-family]'); if (!chip) return;
      activeFamily = chip.dataset.family;
      chipsWrap.querySelectorAll('.hydro-ff__chip').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      render();
    });
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('[data-variant-id]'); if (!card) return;
      var v = variants.filter(function (x) { return String(x.id) === card.dataset.variantId; })[0];
      if (v) { applyVariant(v); closeModal(); }
    });

    var fetchUrl = root.dataset.flavorsUrl;
    var boot = function () {
      buildChips();
      var countTotal = root.querySelector('[data-ff-count-total]');
      if (countTotal) countTotal.textContent = variants.length;
      var current = variants.filter(function (v) { return String(v.id) === (select && select.value); })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (current) updateTrigger(current);
    };
    // Prefer the flavor metaobject data rendered inline; fall back to the bundled asset.
    var inline = document.querySelector('[data-hydro-flavors]');
    if (inline) {
      try { flavorData = JSON.parse(inline.textContent); } catch (e) {}
      boot();
    } else if (fetchUrl) {
      fetch(fetchUrl).then(function (r) { return r.json(); }).then(function (d) { flavorData = d; boot(); }).catch(boot);
    } else { boot(); }
  }

  function initAll() { document.querySelectorAll('[data-hydro-finder]').forEach(initFinder); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
